export default "__VITE_ASSET__Bvy5WcMK__"